import * as yup from "yup";

export const codeSetupValidationSchema = yup.object().shape({
 
});
